import { render, staticRenderFns } from "./VideoChrome.vue?vue&type=template&id=00dc691f&scoped=true&"
import script from "./VideoChrome.vue?vue&type=script&lang=js&"
export * from "./VideoChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc691f",
  null
  
)

export default component.exports